<template>
  <v-card>
    <v-form>
      <v-card-title primary-title>
        <h5 class="subheading mb-0">Bulk SMS</h5>
        <v-spacer></v-spacer>
        <v-btn
          icon
          flat
          :loading="sloading"
          color="green"
          v-if="!(sms_balance && site_online)"
          @click="reloadBalance()"
        >
          <v-icon>refresh</v-icon>
        </v-btn>
        <span>{{
          sms_balance && site_online
            ? sms_balance + " sms remaining"
            : "no sms balance or network error"
        }}</span>
      </v-card-title>
      <v-card-text>
        <v-form ref="form">
          <v-layout row wrap>
            <!-- title -->
            <v-flex xs12>
              <v-autocomplete
                label="Send To:"
                :items="recipients"
                v-model="rcpts_model"
                outline
                :rules="validRules.required"
              ></v-autocomplete>
            </v-flex>
            <v-flex xs12 v-if="rcpts_model == 'Enter Contacts'">
              <v-textarea
                v-model="custom_contacts"
                outline
                hint="Enter phone numbers separated by commas. Eg. 0541234567,0501234567"
              ></v-textarea>
            </v-flex>

            <v-autocomplete
              v-if="rcpts_model == 'Selected Classes'"
              label="Select Classes"
              outline
              :multiple="true"
              :items="classes"
              item-text="name"
              item-value="id"
              :loading="cloading"
              v-model="selected_classes"
              :rules="validRules.required"
            ></v-autocomplete>

            <!-- message box -->
            <v-flex xs12>
              <v-textarea
                filled
                outline
                auto-grow
                label="Message"
                rows="4"
                row-height="30"
                shaped
                v-model="msg"
                :rules="validRules.required"
                :counter="160"
              ></v-textarea>
            </v-flex>
          </v-layout>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="success" :loading="sloading" @click="sendsms()"
          >Send</v-btn
        >
      </v-card-actions>
    </v-form>
  </v-card>
</template>

<script>
import Form from "vform";
import { mapGetters } from "vuex";
import _ from "lodash";

export default {
  name: "profile-view",
  layout: "admin",
  data: () => ({
    recipients: [
      "Whole School",
      "Staff",
      "All Guardians",
      "Selected Classes",
      "Enter Contacts",
    ],
    custom_contacts: "",
    rcpts_model: "",
    msg: "",
    site_online: false,
    sms_senderid: "",
    sms_apiKey: "",
    selected_classes: [],
  }),

  computed: mapGetters({
    user: "authUser",

    students: "students/STUDENTS",

    settings: "settings/SETTINGS",
    errors: "settings/SETTING_ERROR",
    loading: "settings/SETTING_LOADING",

    sms_balance: "sms/SMS_BALANCE",
    serrors: "sms/SMS_ERROR",
    sloading: "sms/SMS_LOADING",
    sms_recipients: "sms/SMS_RCPTS",

    classes: "classes/CLASSES",
    cloading: "classes/CLASS_LOADING",
  }),

  created() {
    this.site_online = navigator.onLine ? true : false;
    //this.$store.dispatch("settings/getAll")
    this.$store.dispatch("classes/getAll");
    this.sms_senderid = this.settings.sms ? this.settings.sms.senderid : "";
    this.sms_apiKey = this.settings.sms ? this.settings.sms.apiKey : "";
    if (this.site_online) {
      this.$store.dispatch("sms/getBalance", this.sms_apiKey);
      this.$store.dispatch("sms/getRecipients");
    }
  },

  methods: {
    reloadBalance() {
      
      this.site_online = navigator.onLine ? true : false;

      if (!this.site_online) {
        this.$store.dispatch("responseMessage", {
          type: "warning",
          text: "Please check your network.",
          title: "SMS",
          modal: false,
        });
      }else{
        this.$store.dispatch("sms/getBalance", this.sms_apiKey);
      }
    },
    sendsms() {
      if (!this.$refs.form.validate()) {
        return;
      }
      let rcpts = "";

      if (!navigator.onLine) {
        this.$store.dispatch("responseMessage", {
          type: "warning",
          text: "Sorry, message could not be sent, please check your internet connection.",
          title: "SMS",
          modal: false,
        });
        return;
      }

      // if (this.sms_balance < 1) {
      //   this.$store.dispatch("responseMessage", {
      //     type: "warning",
      //     text:
      //       "Sorry,your balance is insufficient for this message. Please tell administrator to recharge sms balance.",
      //     title: "SMS",
      //     modal: false,
      //   });

      //   return;
      // }

      if (this.rcpts_model == "Whole School") {
        this.custom_contacts = "";
        rcpts = this.sms_recipients.ws ? this.sms_recipients.ws.filter(x=>this.isValidPhoneNumber(x)) : "";
        rcpts = _.uniq(rcpts).toString();
      } else if (this.rcpts_model == "Staff") {
        this.custom_contacts = "";
        rcpts = this.sms_recipients.stf
          ? this.sms_recipients.stf.filter(x=>this.isValidPhoneNumber(x)).toString()
          : "";
      } else if (this.rcpts_model == "All Guardians") {
        this.custom_contacts = "";
        rcpts = this.sms_recipients.grd ? this.sms_recipients.grd.filter(x=>this.isValidPhoneNumber(x)).toString() : "";
      } else if (this.rcpts_model == "Selected Classes") {
        this.custom_contacts = "";
       
        if (this.selected_classes.length < 1) {
          this.$store.dispatch("responseMessage", {
            type: "warning",
            text: "Please select classes to send SMS.",
            title: "SMS",
            modal: false,
          });
        }
        let res = this.sms_recipients.grd_cls
          ? this.sms_recipients.grd_cls
              .filter((grd) => {
                if (grd.s_guardian) return grd;
              })
              .map((x) => {
                return {
                  class_id: x.class_id,
                  phone: x.s_guardian.phone,
                };
              })
          : [];

        if (res) {
          rcpts = res
            .filter((x) => {
              return this.selected_classes.includes(x.class_id); //get contacts where class id is in selected classes
            })
            .map((v) => {
              return v.phone;
            });
          rcpts = _.uniq(rcpts);
          rcpts = rcpts.filter(x=>this.isValidPhoneNumber(x)).toString();
          //console.log(rcpts)
        } else {
          this.$store.dispatch("responseMessage", {
            type: "warning",
            text: "Sorry,No contacts were found in the selected classes.",
            title: "SMS",
            modal: false,
          });
          return;
        }
        //console.log(rcpts);

        // return;
      } else if (this.rcpts_model == "Enter Contacts") {
        rcpts = this.custom_contacts;
      }

      // console.log(rcpts)
      //return
      if (rcpts) {
        this.$store.dispatch("sms/send", {
          key: this.sms_apiKey,
          to: rcpts,
          msg: this.msg,
          senderid: this.sms_senderid,
        });

        if (this.serrors == null) {
          this.msg = "";
          this.rcpts_model = "";
          this.custom_contacts = "";
          this.$store.dispatch("responseMessage", {
            type: "success",
            text: "SMS sent successfully.",
            title: "SMS",
            modal: false,
          });

          setTimeout(() => {
            this.$store.dispatch("sms/getBalance", this.sms_apiKey);
          }, 1000);
        } else {
          this.$store.dispatch("responseMessage", {
            type: "warning",
            text: "Sorry,an error occured whiles sending SMS.",
            title: "SMS",
            modal: false,
          });
        }
      } else {
        this.$store.dispatch("responseMessage", {
          type: "warning",
          text: "Sorry,there are no recipients for this SMS.",
          title: "SMS",
          modal: false,
        });
      }
    },

    isValidPhoneNumber(inputtxt) {
      var phoneno = /^\d{10}$/;
      return inputtxt.match(phoneno)? true : false;
    },
  },
};
</script>




// WEBPACK FOOTER //
// resources/assets/js/pages/admin/bulksms/bulksms.vue